"use client";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { sidebarNavigationLinksForStudentDashboard } from "@/config/navigation-links";
import { useCreateSignInRedirectURL } from "@/hooks/use-create-sign-in-redirect-url";
import { useClerk, useUser } from "@clerk/nextjs";
import { ChevronDown } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";
import { Button } from "../ui/button";

export default function UserButtonAlt() {
  const { isLoaded, isSignedIn, user } = useUser();
  const { signOut, openUserProfile } = useClerk();

  const signInUrl = useCreateSignInRedirectURL();

  const [clientReady, setClientReady] = useState(false);

  useEffect(() => {
    setTimeout(() => setClientReady(true), 0);
  }, []);

  if (!isLoaded || !clientReady) {
    return <div className="h-10 w-10 rounded-full bg-muted px-0" />;
  }

  if (!isSignedIn) {
    return (
      <Button asChild>
        <Link href={signInUrl}>Sign in</Link>
      </Button>
    );
  }

  const isAdmin = user.publicMetadata.isAdmin;
  const isTeacher = user.publicMetadata.isTeacher;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="group" asChild>
        <Button variant="ghost" className="flex items-center gap-2 px-3">
          <Image
            src={user?.imageUrl}
            alt={`Profile picture of ${user.fullName}`}
            width={32}
            height={32}
            className="overflow-hidden rounded-full"
          />
          <ChevronDown size={18} className="transition group-data-[state=open]:rotate-180" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent sideOffset={10} className="mr-10 max-h-96 overflow-scroll">
        <div className="flex items-center gap-3 rounded-xl bg-muted px-5 py-3">
          <div className="flex h-8 w-8 items-center justify-center overflow-hidden rounded-full">
            <Image src={user?.imageUrl} alt={`Profile picture of ${user.fullName}`} width={32} height={32} />
          </div>
          <div>
            <p className="text-sm font-bold">{user.fullName}</p>
            <p className="text-xs text-muted-foreground">{user.emailAddresses[0].emailAddress}</p>
          </div>
        </div>

        <DropdownMenuGroup className="mt-3 space-y-1 md:mt-2">
          {sidebarNavigationLinksForStudentDashboard.map((link) => {
            return (
              <DropdownMenuItem
                key={link.title}
                onClick={link.title === "Account" ? () => openUserProfile() : undefined}
                asChild
              >
                {link.title === "Account" ? <p>{link.title}</p> : <Link href={link.url}>{link.title}</Link>}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuGroup>

        <DropdownMenuSeparator />

        <DropdownMenuGroup>
          {isAdmin ? (
            <DropdownMenuItem asChild>
              <Link href="/admin">Admin Dashboard</Link>
            </DropdownMenuItem>
          ) : null}

          {isTeacher ? (
            <DropdownMenuItem asChild>
              <Link href="/teacher">Teacher Dashboard</Link>
            </DropdownMenuItem>
          ) : null}

          <DropdownMenuItem
            onClick={() => signOut({ redirectUrl: "/" })}
            className="focus:bg-destructive focus:text-destructive-foreground"
          >
            Sign Out
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

// Recycled

// const { openSignIn } = useClerk();

{
  /* <Button onClick={() => openSignIn()}>Sign in</Button> */
}
{
  /* <OAuthSignInDialog>
       <Button>Sign in</Button>
     </OAuthSignInDialog> */
}

// 27 May 2025

{
  /* <Button onClick={() => router.push(signInUrl)}>Sign in</Button> */
}
